import { Box } from "@mui/material";
import { RESOLVED_STATUS } from "../../constants";
import styles from "./styles.module.scss";
import classNames from "classnames";
import Pill from "../../../common/Pill";

export function ResolvedStatus() {
  return (
    <Pill
      styleName="resolve"
      Lefticon={<img src={"../../../assets/images/svg/judge.svg"} />}>
      <p className={classNames(styles.text, "p2")}>{RESOLVED_STATUS}</p>
    </Pill>
  );
}
